import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ApplicationConfig, inject, importProvidersFrom, provideAppInitializer, provideZoneChangeDetection } from '@angular/core';
import { TitleStrategy, provideRouter, withComponentInputBinding, withRouterConfig } from '@angular/router';
import { MsalInterceptor, MsalModule, MsalService } from '@azure/msal-angular';
import { firstValueFrom } from 'rxjs';

import { routes } from './app.routes';
import {
  msalGuardConfigFactory,
  msalInstanceFactory,
  msalInterceptorConfigFactory,
} from './config/msal-config';
import { RouteInfoTitleStrategy } from './routing/route-info-title-strategy';
import { AuthExpiredInterceptor } from './services/auth-expired.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(
      routes,
      withComponentInputBinding(),
      withRouterConfig({ paramsInheritanceStrategy: 'always' }),
    ),
    provideHttpClient(withInterceptorsFromDi()),
    { provide: TitleStrategy, useClass: RouteInfoTitleStrategy },
    importProvidersFrom(
      MsalModule.forRoot(
        msalInstanceFactory(),
        msalGuardConfigFactory(),
        msalInterceptorConfigFactory(),
      ),
    ),
    { provide: HTTP_INTERCEPTORS, useClass: MsalInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: AuthExpiredInterceptor, multi: true },
    provideAppInitializer(async () => {
      const msalService = inject(MsalService);
      await firstValueFrom(msalService.initialize(), { defaultValue: undefined });
      try {
        await firstValueFrom(msalService.handleRedirectObservable(), { defaultValue: null });
      } catch (error: unknown) {
        console.error('MSAL redirect handling failed', error);
      }
    }),
  ],
};
